export default {"src":"/bnb/_next/static/media/message.3380de5f.svg","height":40,"width":44};